<template>
    <div class="footer">
        <el-row>

            <el-col :span="8">
                <div class="grid-content">
                    <p  class="copyright">© Copyright 2021-2023 GONG Qing All Rights Reserved</p>
                </div>
            </el-col>
            <el-col :span="8">
                <div class="grid-content">
                    <img src="../assets/备案图标.png" style="width: 15px;margin-right:5px"/>
                    <a class="icplink" href="https://beian.mps.gov.cn/#/query/webSearch?code=33010602013385\" target="_blank">浙公网安备33010602013385</a>
                    <a style="margin-left:40px" class="icplink" target="_blank" href="https://beian.miit.gov.cn/?spm=5176.28508143.J_9220772140.60.e939154a3Ui8Au#/Integrated/index" >浙ICP备2022003402号-1</a>
                </div>
            </el-col>
            <el-col :span="8">

                    <div class="footer-content">
                        <i class="el-icon-message"></i>
                        <p>gongqing@zju.edu.cn</p>

                    </div>


<!--                    <div class="footer-content" >-->
<!--                        <i class="el-icon-user"></i>-->
<!--                        <a target="_blank" href="https://github.com/oDumbledoreArmyo">-->
<!--                            <p style="border-bottom: 1px solid black" >Github</p>-->
<!--                        </a>-->
<!--                    </div>-->


<!--                    <div class="footer-content" >-->
<!--                        <i class="el-icon-document"></i>-->
<!--                        <a target="_blank" href="https://www.yuque.com/ogongqingo/qnls">-->
<!--                            <p style="border-bottom: 1px solid black" >Yuque</p>-->
<!--                        </a>-->
<!--                    </div>-->


<!--                    <div class="footer-content" >-->
<!--                        <i class="el-icon-mobile-phone"></i>-->
<!--                        <a target="_blank" href="https://space.bilibili.com/5065303">-->
<!--                            <p style="border-bottom: 1px solid black" >Bilibili</p>-->
<!--                        </a>-->
<!--                    </div>-->

            </el-col>

        </el-row>
    </div>
</template>

<script>
    export default {
        name: "Footer"
    }
</script>

<style scoped>
    .copyright{
        color: #666;
        text-decoration: none;
        font-size: 12px;
    }
    .grid-content{
        min-height: 36px;
        position: center;
        text-align: center;

    }
    .icplink{
        color: #666;
        text-decoration: none;
        font-size: 12px;
    }
    .icplink:hover{
        opacity: 60%;
    }
    .footer{
        margin-top: 200px;
        margin-bottom: 50px;
        min-height: 36px;
    }
    .footer-content{
        float: right;
        padding-right: 50px;


        /*border-right: 1px solid #aaa;*/
    }
    .footer-content i{
        color: #666;
        margin: 0;
        font-size: 25px;
    }
    .footer-content p{
        color: #666;
        font-weight: 400;
        margin: 0  0  0 20px;
        float:right;
    }
</style>
